import { SelectOption } from '@/core/types/SelectOption.ts'
import { frontPaths } from '@/config/frontPaths.ts'

export type OptionMapped<T = any> = {
  original: T
}
export const mapToOption = <T = any>(
  obj: any,
  label: any,
  id: any
): SelectOption<OptionMapped<T>> => ({
  label: typeof label === 'function' ? label(obj) : obj[label],
  id: obj[id],
  original: obj
})

export const mapToOptions = <T, K = any>(list: T[], label: any, id: any) =>
  list.map((obj) => mapToOption<K>(obj, label, id))

// turns ['TEXT'] into [{id: 'TEXT, label: 'Text'}]
export const mapListToOptions = (list: string[]) =>
  list.map((v) => ({
    id: v.toUpperCase(),
    label: v.charAt(0).toUpperCase() + v.slice(1).toLowerCase()
  }))

interface MiObjeto {
  [clave: string]: {
    [subClave: string]: string
  }
}

export const getViewUrlFromModule = (module: string, view: string): string => {
  const paths = frontPaths.modules as MiObjeto
  return paths[module][view]
}

export const getMonthName = (month: number, zeroBased?: boolean) => {
  switch (zeroBased ? month - 1 : month) {
    case 1:
      return 'Enero'
    case 2:
      return 'Febrero'
    case 3:
      return 'Marzo'
    case 4:
      return 'Abril'
    case 5:
      return 'Mayo'
    case 6:
      return 'Junio'
    case 7:
      return 'Julio'
    case 8:
      return 'Agosto'
    case 9:
      return 'Septiembre'
    case 10:
      return 'Octubre'
    case 11:
      return 'Noviembre'
    case 12:
      return 'Diciembre'
    default:
      return ''
  }
}
